export default "__VITE_ASSET__C6_jdeS5__"